/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import {
    Building2,
    ShieldCheck,
    Landmark
} from "lucide-react";

const partners = [

    "HDFC AMC",
    "ICICI Prudential",
    "SBI Mutual Fund",
    "Nippon India",
    "Kotak Mutual Fund",

    "Axis Mutual Fund",
    "UTI Mutual Fund",
    "DSP Mutual Fund",
    "Mirae Asset",
    "Aditya Birla Sun Life",

    "Franklin Templeton",
    "Tata Mutual Fund",
    "Canara Robeco",
    "Bandhan Mutual Fund",
    "Invesco India"
];

export default function PartnerWall() {

    return (

        <section className="mb-24">

            <div className="
                relative
                overflow-hidden
                rounded-[32px]
                bg-gradient-to-br
                from-slate-950
                via-slate-900
                to-blue-950
                p-12
                shadow-2xl
            ">

                {/* Background Glow */}

                <div className="
                    absolute
                    -top-20
                    -left-20
                    w-96
                    h-96
                    rounded-full
                    bg-blue-500/10
                    blur-3xl
                " />

                <div className="
                    absolute
                    -bottom-20
                    -right-20
                    w-96
                    h-96
                    rounded-full
                    bg-emerald-500/10
                    blur-3xl
                " />

                <div className="relative z-10">

                    {/* Header */}

                    <div className="text-center mb-12">

                        <div className="
                            inline-flex
                            items-center
                            gap-2
                            px-4
                            py-2
                            rounded-full
                            border
                            border-white/10
                            bg-white/5
                            text-slate-300
                            text-sm
                            mb-6
                        ">

                            <ShieldCheck size={16} />

                            Trusted Investment Ecosystem

                        </div>

                        <h2 className="
                            text-4xl
                            md:text-5xl
                            font-bold
                            text-white
                            mb-5
                        ">
                            Connected Across India's
                            Investment Landscape
                        </h2>

                        <p className="
                            text-slate-400
                            text-lg
                            max-w-3xl
                            mx-auto
                        ">
                            Orion Analytics integrates research,
                            analytics and investment access across
                            leading mutual fund houses and market
                            participants.
                        </p>

                    </div>

                    {/* Stats */}

                    <div className="
                        grid
                        md:grid-cols-3
                        gap-6
                        mb-12
                    ">

                        <div className="
                            bg-white/5
                            border
                            border-white/10
                            rounded-2xl
                            p-6
                            text-center
                        ">
                            <Landmark
                                size={28}
                                className="
                                    text-blue-400
                                    mx-auto
                                    mb-3
                                "
                            />

                            <div className="
                                text-3xl
                                font-bold
                                text-white
                            ">
                                15+
                            </div>

                            <div className="text-slate-400">
                                Fund Houses
                            </div>

                        </div>

                        <div className="
                            bg-white/5
                            border
                            border-white/10
                            rounded-2xl
                            p-6
                            text-center
                        ">
                            <Building2
                                size={28}
                                className="
                                    text-emerald-400
                                    mx-auto
                                    mb-3
                                "
                            />

                            <div className="
                                text-3xl
                                font-bold
                                text-white
                            ">
                                3000+
                            </div>

                            <div className="text-slate-400">
                                Mutual Fund Schemes
                            </div>

                        </div>

                        <div className="
                            bg-white/5
                            border
                            border-white/10
                            rounded-2xl
                            p-6
                            text-center
                        ">
                            <ShieldCheck
                                size={28}
                                className="
                                    text-yellow-400
                                    mx-auto
                                    mb-3
                                "
                            />

                            <div className="
                                text-3xl
                                font-bold
                                text-white
                            ">
                                ARN
                            </div>

                            <div className="text-slate-400">
                                Registered Distributor
                            </div>

                        </div>

                    </div>

                    {/* Partner Grid */}

                    <div className="
                        grid
                        grid-cols-2
                        md:grid-cols-3
                        lg:grid-cols-5
                        gap-4
                    ">

                        {partners.map((partner) => (

                            <div
                                key={partner}
                                className="
                                    bg-white/5
                                    border
                                    border-white/10
                                    rounded-2xl
                                    py-6
                                    px-4
                                    text-center
                                    text-slate-300
                                    font-medium
                                    hover:bg-white/10
                                    hover:text-white
                                    transition-all
                                    duration-300
                                "
                            >
                                {partner}
                            </div>

                        ))}

                    </div>

                </div>

            </div>

        </section>

    );
}